import ko from "knockout";
import metaCache from "flow/utils/metaCache";

ko.validation.rules["atLeastOnePicked"] = {
    validator: function (value: any[]) {
        return value && Array.isArray(value) && value.length > 0;
    },
    message: () => metaCache.translate("FlowHtml.Translations.AtLeastOneMustBePicked")
};

ko.validation.registerExtenders();
